import ZTable from './z-table.vue'

ZTable.install = (Vue) => {
  Vue.component(ZTable.name, ZTable)
}

export default ZTable
